// extracted by mini-css-extract-plugin
export default {"settings":"zqiUP","label":"oXD3L"};